import { useEffect } from "react";

/**
 * Tells the pre-React watchdog in public/index.html that the first React tree
 * has committed, so it must not draw its static fallback over the app.
 *
 * Effects run only after a commit, so if the initial tree throws before it
 * commits the flag stays unset and the watchdog's Reload fallback still shows.
 */
export default function MountSignal() {
  useEffect(() => {
    window.__ioReactMounted = true;
  }, []);
  return null;
}
